/**
 * Declares the asUser prop on components.
 * If they then use asyncOperations(props) - they will use custom permissions for all their requests
 */
export default {
  install(app) {
    app.mixin({
      props: {
        asUser: {
          type: [String,Boolean],
          default: false,
        }
      },
      updated() {},
      created() {},
      mounted() {},
    });
  },
};
